import { createStyles, makeStyles, Slide } from '@material-ui/core'
import { Config } from '../../config'
import React from 'react'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: '100vh',
      background:
        'linear-gradient(180deg, rgba(51, 51, 51, 0.2) 0%, #333333 100%), linear-gradient(197.24deg, #46A4E0 0%, #246193 98.81%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  })
)

const SplashScreen: React.FC = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Slide
        direction="right"
        in={true}
        mountOnEnter
        unmountOnExit
        timeout={{ enter: 500, appear: 200, exit: 500 }}
      >
        <img src={Config.logo} alt="APP LOGO" />
      </Slide>
    </div>
  )
}

export default SplashScreen
